module.exports = __webpack_public_path__ + "img/entities.916ef799.svg";